import React from 'react';
import { Row, Col, Typography } from 'antd';
import { useTranslation } from 'next-i18next';

const { Title, Paragraph, Text } = Typography;

interface SEOSectionProps {
  t?: any;
}

const SEOSection: React.FC<SEOSectionProps> = ({ t: tProp }) => {
  const { t: tFunc } = useTranslation('home');
  const t = tProp || tFunc;

  const fontFamily = {
    fontFamily: "'Sarabun', sans-serif"
  };

  return (
    <div style={{ 
      backgroundColor: '#FFFFFF',
      padding: '96px 0',
      width: '100%',
      ...fontFamily
    }}>
      <div style={{ 
        maxWidth: '1496px', 
        margin: '0 auto',
        padding: '0 16px'
      }}>
        <Title level={1} style={{ 
          fontSize: '40px', 
          fontWeight: 500, 
          color: '#F4762A',
          marginBottom: '24px',
          ...fontFamily
        }}>
          {t('seo_section.title')}
        </Title>
        
        <Paragraph style={{ 
          fontSize: '16px', 
          fontWeight: 400, 
          color: '#717172',
          marginBottom: '40px',
          ...fontFamily
        }}>
          {t('seo_section.description')}
        </Paragraph>

        <Row gutter={32}>
          <Col xs={24} sm={24} md={8}>
            <Title level={3} style={{ 
              fontSize: '16px', 
              fontWeight: 600, 
              color: '#F4762A',
              marginBottom: '16px',
              ...fontFamily
            }}>
              {t('seo_section.buying_selling_renting.title')}
            </Title>
            
            <Title level={4} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '12px',
              ...fontFamily
            }}>
              {t('seo_section.buying_selling_renting.subtitle')}
            </Title>
            
            <Paragraph style={{ 
              fontSize: '14px', 
              fontWeight: 400, 
              color: '#717172',
              ...fontFamily
            }}>
              {t('seo_section.buying_selling_renting.content')}
            </Paragraph>

            <Title level={3} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '12px',
              ...fontFamily
            }}>
              {t('seo_section.investment.title')}
            </Title>
            
            <Paragraph style={{ 
              fontSize: '14px', 
              fontWeight: 400, 
              color: '#717172',
              marginBottom: '24px',
              ...fontFamily
            }}>
              {t('seo_section.investment.content')}
            </Paragraph>
          </Col>
          
          <Col xs={24} sm={24} md={8}>
            <Title level={3} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '12px',
              ...fontFamily
            }}>
              {t('seo_section.choosing_website.title')}
            </Title>
            
            <Paragraph style={{ 
              fontSize: '14px', 
              fontWeight: 400, 
              color: '#717172',
              ...fontFamily
            }}>
              {t('seo_section.choosing_website.content')}
            </Paragraph>

            <Title level={3} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '12px',
              ...fontFamily
            }}>
              {t('seo_section.benefits.title')}
            </Title>
            
            <Title level={5} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '8px',
              marginTop: '16px',
              ...fontFamily
            }}>
              {t('seo_section.benefits.point1.title')}
            </Title>
            
            <Paragraph style={{ 
              fontSize: '14px', 
              fontWeight: 400, 
              color: '#717172',
              marginBottom: '16px',
              ...fontFamily
            }}>
              {t('seo_section.benefits.point1.content')}
            </Paragraph>
            
            <Title level={5} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '8px',
              marginTop: '16px',
              ...fontFamily
            }}>
              {t('seo_section.benefits.point2.title')}
            </Title>
            
            <Paragraph style={{ 
              fontSize: '14px', 
              fontWeight: 400, 
              color: '#717172',
              marginBottom: '16px',
              ...fontFamily
            }}>
              {t('seo_section.benefits.point2.content')}
            </Paragraph>
            
            <Title level={5} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '8px',
              marginTop: '16px',
              ...fontFamily
            }}>
              {t('seo_section.benefits.point3.title')}
            </Title>
            
            <Paragraph style={{ 
              fontSize: '14px', 
              fontWeight: 400, 
              color: '#717172',
              marginBottom: '24px',
              ...fontFamily
            }}>
              {t('seo_section.benefits.point3.content')}
            </Paragraph>
          </Col>
          
          <Col xs={24} sm={24} md={8}>
            <Title level={3} style={{ 
              fontSize: '14px', 
              fontWeight: 600, 
              color: '#000000',
              marginBottom: '12px',
              ...fontFamily
            }}>
              {t('seo_section.tips.title')}
            </Title>
            
            <Paragraph style={{ 
              fontSize: '14px', 
              fontWeight: 400, 
              color: '#717172',
              ...fontFamily
            }}>
              {t('seo_section.tips.content')}
            </Paragraph>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export { SEOSection };
export default SEOSection; 